import React, { useState, useEffect, useContext } from "react";
import clienteAxios from "../../../config/axios";
import { Result, Row, Col, Card } from "antd";
import { Link, withRouter } from "react-router-dom";
import "./ofertas.scss";
/* import ComponenteProductoGrande from "../Productos/Card_Grande/componente_producto_grande"; */
// import ComponenteProductos from '../Productos/componente_productos';
/* import CardSecundaria from "../Productos/Card_Secundaria/card_secundaria"; */

import Spin from "../../../components/Spin";
import Card_Producto from "../Productos/Cards_Normales/card_producto";
import { Container } from "@material-ui/core";
import { agregarPorcentaje, formatoMexico } from "../../../config/reuserFunction";
import aws from "../../../config/aws";
import { makeStyles } from "@material-ui/styles";
import { MenuContext } from "../../../context/carritoContext";
import CardOferta from "./card_oferta";

const gridStyle = { width: "100%", padding: 0, marginBottom: "1.5rem" };

function OfertasHome(props) {
  /* const { orientacion } = props; */
  const { colores } = useContext(MenuContext);
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);

  const useStyles = makeStyles({
    background: {
      backgroundColor: colores.bodyPage.card.background,
      border: "none",
      "& .text-color": {
        color: colores.bodyPage.card.text,
      },
    },
  });
  const classes = useStyles();

  useEffect(() => {
    obtenerProductos();
  }, []);

  async function obtenerProductos() {
    setLoading(true);
    await clienteAxios
      .get(`/productos/promociones?limit=${12}&page=${1}`)
      .then((res) => {
        const { docs } = res.data.posts;
        setProductos(docs);
        setLoading(false);
      })
      .catch((err) => {
        props.history.push("/error500");
      });
  }

  const render = productos.map((promocion, index) => {
    const {productoPromocion, precioPromocion} = promocion;

    return (
      <Col key={index} xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
        <CardOferta producto={productoPromocion} precioPromocion={precioPromocion} />
      </Col>
    );
  });

  if (productos.length === 0) {
    return null;
  }

  return (
    <Spin spinning={loading}>
      {/* <div className="contenedor-home-background">
				<div className="row contenedor-home-banner">
					<h4 className="mb-0 font-weight-bold">¡Encuentra ofertas todos los días!</h4> 
				</div>
			</div> */}
      <div>
        <h4 className="font-weight-bold mx-5">
          ¡Encuentra ofertas todos los días!
        </h4>
      </div>
      <Container>
        {productos.length ? (
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>{render}</Row>
        ) : (
          <div className="w-100 d-flex justify-content-center align-items-center">
            <Result status="404" title="Aun no hay ofertas" />
          </div>
        )}
      </Container>
      <div className="d-flex justify-content-center pb-5">
        <Link to="/ofertas" style={{ fontSize: 18 }}>
          Ver Todas las ofertas
        </Link>
      </div>
    </Spin>
  );
}

export default withRouter(OfertasHome);
